import type { OpenConversationOptions } from '@/hooks/use-chat-surface-registry'

type RegistryLike = {
  openThread: (threadId: string, options?: OpenConversationOptions) => void
  registerThreadTitle?: (threadId: string, title: string) => void
}

/** Open an agent_chat thread in the editor tab or agent panel per registry preference. */
export function openAgentChatThread(
  registry: RegistryLike | null | undefined,
  threadId: string,
  options?: Pick<OpenConversationOptions, 'title' | 'openInNewTab' | 'clickEvent' | 'forceAgentPanel' | 'forceEditor'>,
): void {
  if (options?.title) {
    registry?.registerThreadTitle?.(threadId, options.title)
  }
  if (registry) {
    registry.openThread(threadId, options)
    return
  }
  // No registry: editor tab via layout event; agent panel via surface-move after open.
  if (options?.forceAgentPanel) {
    window.dispatchEvent(
      new CustomEvent('chat-surface-move', {
        detail: { threadId, target: 'agent-panel' as const },
      }),
    )
    return
  }
  window.dispatchEvent(
    new CustomEvent('open-chat-conversation-main', {
      detail: {
        threadId,
        title: options?.title,
        openInNewTab: options?.openInNewTab ?? options?.forceEditor ?? true,
        clickEvent: options?.clickEvent,
      },
    }),
  )
}
